import { render, staticRenderFns } from "./logList.vue?vue&type=template&id=38eba644&scoped=true&"
import script from "./logList.vue?vue&type=script&lang=js&"
export * from "./logList.vue?vue&type=script&lang=js&"
import style0 from "./logList.vue?vue&type=style&index=0&id=38eba644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eba644",
  null
  
)

export default component.exports